import { axios } from '../index'

export const deleteTemplate = async (id: string) => {
  return axios.delete(`/v1/template-gallery/${id}`)
}
